import React from 'react'
import type { BodyRowConfig } from '@ztechapps/webui.data-tools'
import { RowNumberBodyCell } from '@ztechapps/webui.data-tools'
import type { CompanyWithContacts, RouteDef } from '@ztechapps/common.contract'
import { useInject, WebuiIocKey } from '@ztechapps/webui.contract'
import { CompanyRenderDataBodyCellConfig } from './CompanyDataListRow'

export const CompanyRow = (props: BodyRowConfig<CompanyWithContacts>) => {
  const companyRoute = useInject<RouteDef>(WebuiIocKey.routes.customerCompanyItem)
  const companyRenderDataBodyCellConfig = CompanyRenderDataBodyCellConfig({ ...props, companyRoute })

  return (
    <>
      <RowNumberBodyCell {...props} />
      {props._renderDataBodyCell(companyRenderDataBodyCellConfig)}
    </>
  )
}
